import React__default from 'react';

const TooltipMessage = ({ message  })=>{
    if (typeof message === 'string') {
        return /*#__PURE__*/ React__default.createElement("div", {
            className: "tooltip__message-content"
        }, message);
    }
    if (/*#__PURE__*/ React__default.isValidElement(message)) {
        return message;
    }
    return null;
};

export { TooltipMessage };
//# sourceMappingURL=TooltipMessage.js.map
